export const TIME_ATTENDANCE = {
  ERROR_NOTIFICATION: 0,
  ALERT_NOTIFICATION: 1,
  DO_NOT_NOTIFY: 2,
};
export const WORK_STYLE_ALERT = {
  ALERT_NOTIFICATION: 0,
  DO_NOT_NOTIFY: 1,
};
